import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class BreadcrumbComponent implements OnInit {

  @Input() consumer = false;
  _items: any;

  get items(): any {
      return this._items;
  }
  @Input() set items(value: any) {
      this._items = value;
  }

  constructor() { }

  ngOnInit() {
  }

}
